import { AspectRatio } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { NodeResizeControl, ReactFlowState, useStore } from 'reactflow'

const zoomSelector = (state: ReactFlowState) => state.transform[2]

interface Props {
  isEditable?: boolean
  onResize: (width: number, height: number) => void
}
export const NodeResizer = ({ isEditable, onResize }: Props) => {
  const theme = useMinimalsTheme()
  const zoom = useStore(zoomSelector)

  if (!isEditable) return <></>

  return (
    <NodeResizeControl
      minWidth={100}
      minHeight={50}
      onResizeEnd={(_, params) => onResize(params.width, params.height)}
      position='bottom-left'
    >
      <Box
        className='nodrag'
        sx={{
          position: 'absolute',
          bottom: -16,
          left: -16,
          width: 32,
          height: 32,
          borderRadius: '50%',
          backgroundColor: theme.palette.common.white,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'crosshair',
          transform: `scale(${1 / zoom})`,
          transformOrigin: 'bottom left',
        }}
      >
        <AspectRatio />
      </Box>
    </NodeResizeControl>
  )
}
